import {combineReducers} from 'redux';
import dataReducer, * as fromData from './dataReducer';
import adminReducer, * as fromAdmin from './adminReducer';
import applicationReducer, * as fromApplication from './applicationReducer';
import selectStagReducer, * as fromSelectStag from './selectStagReducer';
import userReducer, * as fromUser from './userReducer';
import pollsReducer, * as fromPolls from './pollsReducer';

export default combineReducers({
  data: dataReducer,
  admin: adminReducer,
  application: applicationReducer,
  selectStag: selectStagReducer,
  user: userReducer,
  polls: pollsReducer,
});

// *** ACTIONS

export const fetchData = fromData.fetchData;
export const registerPeopleListener = fromData.registerPeopleListener;
export const registerAgendaListener = fromData.registerAgendaListener;
export const registerHomepageListener = fromData.registerHomepageListener;
export const registerPointsListener = fromData.registerPointsListener;
export const deregisterHomepageListener = fromData.deregisterHomepageListener;
export const deregisterAgendaListener = fromData.deregisterAgendaListener;
export const deregisterPeopleListener = fromData.deregisterPeopleListener;
export const deregisterPointsListener = fromData.deregisterPointsListener;

export const registerPollsListener = fromPolls.registerPollsListener;
export const deregisterPollsListener = fromPolls.deregisterPollsListener;
export const respondToPollChoice = fromPolls.respondToPollChoice;

export const editHomepage = fromAdmin.editHomepage;
export const cancelEditHomepage = fromAdmin.cancelEditHomepage;
export const updateHomepage = fromAdmin.updateHomepage;
export const uploadHomepageImage = fromAdmin.uploadHomepageImage;
export const saveHomepage = fromAdmin.saveHomepage;

export const editPeople = fromAdmin.editPeople;
export const addPerson = fromAdmin.addPerson;
export const removePerson = fromAdmin.removePerson;
export const updatePerson = fromAdmin.updatePerson;
export const cancelEditPeople = fromAdmin.cancelEditPeople;
export const savePeople = fromAdmin.savePeople;

export const editAgenda = fromAdmin.editAgenda;
export const cancelEditAgenda = fromAdmin.cancelEditAgenda;
export const saveAgenda = fromAdmin.saveAgenda;
export const updateAgendaDay = fromAdmin.updateAgendaDay;
export const addAgendaDay = fromAdmin.addAgendaDay;
export const removeAgendaDay = fromAdmin.removeAgendaDay;
export const updateAgendaItem = fromAdmin.updateAgendaItem;
export const removeAgendaItem = fromAdmin.removeAgendaItem;
export const addAgendaItem = fromAdmin.addAgendaItem;
export const addPersonToAgendaDay = fromAdmin.addPersonToAgendaDay;
export const removePersonFromAgendaDay = fromAdmin.removePersonFromAgendaDay;
export const setAgendaDayPeople = fromAdmin.setAgendaDayPeople;
export const clearAgendaDayPeople = fromAdmin.clearAgendaDayPeople;
export const uploadAgendaItemMedia = fromAdmin.uploadAgendaItemMedia;
export const addAgendaDayAccommodationRoom = fromAdmin.addAgendaDayAccommodationRoom;
export const removeAgendaDayAccommodationRoom = fromAdmin.removeAgendaDayAccommodationRoom;
export const addPersonToAccommodationRoom = fromAdmin.addPersonToAccommodationRoom;
export const removePersonFromAccommodationRoom = fromAdmin.removePersonFromAccommodationRoom;

export const addPointsChange = fromAdmin.addPointsChange;

export const addSpecialCount = fromApplication.addSpecialCount;
export const clearSpecialCount = fromApplication.clearSpecialCount;
export const hideAdminVisibility = fromApplication.hideAdminVisibility;
export const registerOnlineListener = fromApplication.registerOnlineListener;

export const getStagForCode = fromSelectStag.getStagForCode;
export const getCodeForStag = fromSelectStag.getCodeForStag;
export const setSelectedStag = fromSelectStag.setSelectedStag;
export const deregisterStagListeners = fromSelectStag.deregisterStagListeners;
export const createNewStag = fromSelectStag.createNewStag;
export const getUserStags = fromSelectStag.getUserStags;
export const joinStag = fromSelectStag.joinStag;
export const updateStagAttendance = fromSelectStag.updateStagAttendance;
export const registerUserStagsListener = fromSelectStag.registerUserStagsListener;

export const checkAuthStatus = fromUser.checkAuthStatus;
export const registerAuthListener = fromUser.registerAuthListener;
export const loginViaGoogle = fromUser.loginViaGoogle;
export const loginViaFacebook = fromUser.loginViaFacebook;
export const logout = fromUser.logout;

// *** SELECTORS

export const peopleSelector = (state) => fromData.peopleSelector(state.data);
export const agendaSelector = (state) => fromData.agendaSelector(state.data);
export const homepageSelector = (state) => fromData.homepageSelector(state.data);
export const agendaDatesSelector = (state) => fromData.agendaDatesSelector(state.data);
export const pointsSelector = (state) => fromData.pointsSelector(state.data);
export const homepageTitleSelector = (state) => fromData.homepageTitleSelector(state.data);
export const hasStagDataSelector = (state) => fromData.hasStagDataSelector(state.data);

export const stagExistsSelector = (state) => {
  if ( (peopleSelector(state) || agendaSelector(state) || homepageSelector(state) || pointsSelector(state) || pollsSelector(state)) ) {
    return true;
  }
  return false;
};

export const peopleLoadingSelector = (state) => fromData.peopleLoadingSelector(state.data);
export const agendaLoadingSelector = (state) => fromData.agendaLoadingSelector(state.data);
export const homepageLoadingSelector = (state) => fromData.homepageLoadingSelector(state.data);
export const pointsLoadingSelector = (state) => fromData.pointsLoadingSelector(state.data);
export const peopleWithPointsSelector = (state) => fromData.peopleWithPointsSelector(state.data);

export const pollsSelector = (state) => fromPolls.pollsSelector(state.polls);
export const pollsLoadingSelector = (state) => fromPolls.pollsLoadingSelector(state.polls);
export const pollSelector = (state, pollId) => fromPolls.pollSelector(state.polls, pollId);
export const pollResponsesSelector = (state, pollId) => fromPolls.pollResponsesSelector(state.polls, pollId);

export const peopleEditSelector = (state) => fromAdmin.peopleEditSelector(state.admin);
export const agendaEditSelector = (state) => fromAdmin.agendaEditSelector(state.admin);
export const homepageEditSelector = (state) => fromAdmin.homepageEditSelector(state.admin);
export const peopleSavingSelector = (state) => fromAdmin.peopleSavingSelector(state.admin);
export const agendaSavingSelector = (state) => fromAdmin.agendaSavingSelector(state.admin);
export const homepageSavingSelector = (state) => fromAdmin.homepageSavingSelector(state.admin);
export const homepageImageSavingSelector = (state) => fromAdmin.homepageImageSavingSelector(state.admin);
export const agendaItemMediaSavingSelector = (state) => fromAdmin.agendaItemMediaSavingSelector(state.admin);

export const adminVisibleSelector = (state) => fromApplication.adminVisibleSelector(state.application);
export const networkStatusSelector = (state) => fromApplication.networkStatusSelector(state.application);
export const checkingNetworkStatusSelector = (state) => fromApplication.checkingNetworkStatusSelector(state.application);
export const newContentAvailableSelector = (state) => fromApplication.newContentAvailableSelector(state.application);
export const contentCachedSelector = (state) => fromApplication.contentCachedSelector(state.application);

export const stagCodeSelector = (state) => fromSelectStag.stagCodeSelector(state.selectStag);
export const selectedStagSelector = (state) => fromSelectStag.selectedStagSelector(state.selectStag);
export const userIsAdminForStag = (state, stag) => fromSelectStag.userIsAdminForStag(state.selectStag, stag);
export const userStagsSelector = (state) => fromSelectStag.userStagsSelector(state.selectStag);
export const userCreatedStagsSelector = (state) => fromSelectStag.userCreatedStagsSelector(state.selectStag);
export const fetchingUserStagsSelector = (state) => fromSelectStag.fetchingUserStagsSelector(state.selectStag);
export const userHasJoinedStagSelector = (state) => fromSelectStag.userHasJoinedStagSelector(state.selectStag);

export const authStatusSelector = (state) => fromUser.authStatusSelector(state.user);
export const checkingAuthStatusSelector = (state) => fromUser.checkingAuthStatusSelector(state.user);
export const loginErrorSelector = (state) => fromUser.loginErrorSelector(state.user);
export const userIdSelector = (state) => fromUser.userIdSelector(state.user);

export const userAttendanceStatusSelector = (state) => {
  const people = peopleSelector(state);
  const user = userIdSelector(state);
  return (people && people[user]) ? people[user].attending : null;
};



// WEBPACK FOOTER //
// ./src/reducers/index.js